import React from 'react';

const SIZE = 50;
export default function SpinnerIcon(props) {
  return (
    <svg width={props.size || SIZE} height={props.size || SIZE} viewBox="0 0 100 100">
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke={props.color || '#66bb6a'}
        strokeWidth="10"
        r="35"
        strokeDasharray="164.93361431346415 56.97787143782138"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        />
      </circle>
    </svg>
  );
}
